var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCelebrationFlags = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 264,
  height: 60,
  viewBox: "0 0 264 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_3122_267",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 264,
  height: 60
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M263.5 0.108887H0.5V60H263.5V0.108887Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_3122_267)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask1_3122_267",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: -39,
  width: 264,
  height: 99
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M263.883 -38.8203H0.882812V60H263.883V-38.8203Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_3122_267)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3027 34.3806L13.63 1.38749L13.7122 0.0874634L41.4627 13.465C41.4627 13.465 40.9111 14.201 39.8226 15.1643L13.3027 34.3806Z",
  fill: "#FFBF50"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.4865 50.8838L51.8156 18.3782L51.6602 17.0848L81.3805 25.2184C81.3805 25.2184 80.9715 26.0421 80.0765 27.1865L57.4865 50.8838Z",
  fill: "#4CAABF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.656 59.0138L95.539 28.3159L95.126 27.0804L125.878 29.0685C125.878 29.0685 125.644 29.9575 124.998 31.2586L107.656 59.0138Z",
  fill: "#F2564C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M156.44 57.8272L138.279 30.2589L137.621 29.134L168.129 24.7903C168.129 24.7903 168.083 25.7083 167.717 27.1139L156.44 57.8272Z",
  fill: "#8D85FF",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M203.904 47.9081L182.136 23.0781L181.33 22.0537L210.957 13.5859C210.957 13.5859 211.036 14.5016 210.867 15.9438L203.904 47.9081Z",
  fill: "#FFBF50"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M247.312 32.7074L222.706 10.6764L221.782 9.75634L250.063 -2.02054L247.312 32.7074Z",
  fill: "#1FA6D1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-34.6895 -35.1224C-34.6895 -35.1224 23.794 21.2361 107.452 27.1064C191.11 32.9767 273.984 -16.5577 273.984 -16.5577",
  stroke: "#D4D3FF",
  strokeWidth: 4,
  strokeLinecap: "round"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCelebrationFlags);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/celebrationFlags.c9ab7f5843c47465c74e834f5c5e1c4b.svg";